<template>
  <div>
    <el-dialog :visible.sync="isShowImport" title="上传进度" @close="doClose()" style="height: 200px;">
      <el-progress :percentage="process"></el-progress>
    </el-dialog>
  </div>
</template>

<script>
import {getSyncTaskProcessApi} from './api'

export default {
  name: 'ImportProgressBar',

  props: {
    import_task_id: {
      type: String,
      default: ''
    },
    isShowImport: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      process: 0,
      timer: null,
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  watch: {
    isShowImport: function () {
      if (! this.isShowImport) {
        clearInterval(this.timer);
      }
    }
  },
  mounted() {
    this.timer = setInterval(this.fetchData, 3000);  // 每5秒执行一次fetchData方法
  },
  methods: {
    doClose() {
      this.$emit('close')
    },
    fetchData() {
      getSyncTaskProcessApi(this.import_task_id).then(res => {
        this.process = res.process
      })
    }
  }
}
</script>
